import { useState } from 'react'

import { Card, Dialog } from '@mui/material'

import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import MDTypography from 'components/MDTypography'

import { ChangeLogType } from './types'

type Props = {
	log?: ChangeLogType[]
}
const ChangeLog = ({ log }: Props) => {
	const [dialogOpen, setDialogOpen] = useState<boolean>(false)
	return (
		<Card>
			<Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
				<MDBox
					width={'30vw'}
					height={'40vh'}
					style={{
						backgroundColor: '#fff',
						overflowY: 'scroll',
						overflowX: 'hidden',
						scrollbarWidth: 'none',
					}}
				>
					<MDBox
						p={3}
						display={'flex'}
						flexDirection={'column'}
						justifyContent={'center'}
						alignItems={'center'}
						gap={1}
					>
						<MDTypography variant="h3">{'Change Log'}</MDTypography>
						<MDBox display={'flex'} flexDirection={'column'} mt={1} gap={2}>
							{log?.map((item, index) => (
								<MDTypography key={index} variant="body2" color="text" fontWeight="medium">
									<li>
										<i>{item.datetime}</i> - {item.details} by {item.user_name}
									</li>
								</MDTypography>
							))}
						</MDBox>
					</MDBox>
				</MDBox>
			</Dialog>
			<MDBox p={2}>
				<MDTypography variant="h5">Change Log</MDTypography>
				<MDBox display={'flex'} flexDirection={'column'} mt={1} gap={1}>
					{log
						?.filter((item, index) => {
							if (index < 2) return true
							return false
						})
						?.map((item, index) => (
							<MDTypography key={index} variant="button" color="text" fontWeight="medium">
								<li>
									<i>{item.datetime}</i> - {item.details} by {item.user_name}
								</li>
							</MDTypography>
						))}
					{log?.length > 2 && (
						<MDTypography variant="button" color="text" fontWeight="medium" pl={2}>
							<i>+ 2 more</i>
						</MDTypography>
					)}
					{(!log || log.length === 0) && (
						<MDTypography variant="button" color="text" fontWeight="medium">
							<i>No entries</i>
						</MDTypography>
					)}
				</MDBox>
				{log?.length > 2 && (
					<MDBox display="flex" justifyContent="center" mt={1}>
						<MDButton
							variant="text"
							color="info"
							onClick={() => {
								setDialogOpen(true)
							}}
						>
							View Full Change Log
						</MDButton>
					</MDBox>
				)}
			</MDBox>
		</Card>
	)
}

export default ChangeLog
